import axios from 'axios';
import router from '@/router'
import message from "@/components/message"


export class baseApi {
	axios;
	userBody;
	router = "";
	method = "get";
	responseType = "json";
	files = [];		//文件
	baseURL = '/api';
	setFile(fild, file) {
		this.files.push({
			fild,
			file,
		});
		return this;
	}
	run(param) {
		param = this.runConversion(param);
		if (param == false) {
			return;
		}
		this.axios = axios.create({
			withCredentials: true,
			baseURL: this.baseURL,
			validateStatus: function (status) {
				return status == 200;
			},
			responseType: this.responseType,
			maxContentLength: 200000
		});
		this.axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
		let response;
    // message.loading();
		switch (this.method) {
			case "get":
				this.axios.defaults.headers["Content-Type"] = "application/json";
				return this.axios.get(this.router, { params: param }).then(response => {
          // message.unload();
					let data = this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error => {
          // message.unload();
					if (error.response) {
						this.errorHandel(error.response.status, error.response.data)
					} else {
						throw error;
					}
				})
				break;
			case "post":
				this.axios.defaults.headers["Content-Type"] = "application/json";
				return this.axios.post(this.router, param).then(response => {
          // message.unload();
					let data = this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error => {
          // message.unload();
					if (error.response) {
						this.errorHandel(error.response.status, error.response.data)
					} else {
						throw error;
					}
				})
				break;
			case "delete":
				this.axios.defaults.headers["Content-Type"] = "application/json";
				let axiosParam = { params: param };
				if (this.userBody) {
					axiosParam = { data: param };
				}
				return this.axios.delete(this.router, axiosParam).then(response => {
          // message.unload();
					let data = this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error => {
          // message.unload();
					if (error.response) {
						this.errorHandel(error.response.status, error.response.data)
					} else {
						throw error;
					}

				})
				break;
			case "file":
				this.axios.defaults.headers["Content-Type"] = "multipart/form-data";
				let form = new FormData();
				for (let i in this.files) {
					form.append(this.files[i].fild, this.files[i].file);
				}
				return this.axios.post(this.router, form, {
					onUploadProgress: (e) => {
						let percents = Math.round((e.loaded * 100) / e.total);
						if (this.progress) {
							this.progress(percents);
						}
					}
				}).then(response => {
          // message.unload();
					let data = this.conversion(response.data)
					this.beforSuccess(data)
					this.successHandel(data);
				}).catch(error => {
          // message.unload();
					if (error.response) {
						this.errorHandel(error.response.status, error.response.data)
					} else {
						this.errorHandel(null, null)
						throw error;
					}
				})
				break;
		}
	}

	setError(status, fun) {
		switch (status) {
			case 500:
				this.error500 = fun;
				break;
			case 400:
				this.error400 = fun;
				break;
		}
		return this;
	}



	setProgress(fn) {
		this.progress = fn;
		return this;
	}
	error400(response) { //400错误
		message.error(response.message)
	}
	error500(response) { //500错误
		message.error(response.message)
	}
	afterError(response) {
	}
	beforSuccess(response) {
	}
	runConversion(param) {
		return param;
	}
	conversion(response) {
		return response;
	}
	success(fun) {
		this.successHandel = fun;
		return this;
	}
	successHandel(response) {

	}

	error(fun) {
		this.errorCommon = fun;
		return this;
	}
	errorCommon(status, response) {

	}
	errorHandel(status, response) {
		this.errorCommon(status, response);

    switch (status) {
      case 500:
        this.error500(response);
        break;
      case 400:
        this.error400(response);
        break;
      default:

        //网络断开
        break
    }

		this.afterError(response)
	}
}



// WEBPACK FOOTER //
// ./src/api/base.js